(function (window) {
  'use strict';

  if (!window) return;

  var LOCALE_MAP = {
    de: 'de',
    es: 'es',
    fr: 'fr',
    it: 'it',
    ja: 'ja',
    nl: 'nl',
    pt: 'pt',
    'pt-pt': 'pt',
    zh: 'zh',
    'zh-cn': 'zh'
  };

  function normalizeLocaleCode(code) {
    return String(code || '')
      .trim()
      .toLowerCase()
      .replace(/_/g, '-');
  }

  function resolveLocaleKey(code, flatpickr) {
    var normalized = normalizeLocaleCode(code);
    var firstPart = normalized.split('-')[0];
    var localeKey = LOCALE_MAP[normalized] || LOCALE_MAP[firstPart] || firstPart;

    if (flatpickr && flatpickr.l10ns && flatpickr.l10ns[localeKey]) {
      return localeKey;
    }

    return 'default';
  }

  function initBirthdayPicker(options) {
    var config = options || {};
    var input = config.input;
    var flatpickr = window.flatpickr;

    if (!flatpickr || !input) return null;

    var localeKey = resolveLocaleKey(
      config.localeCode || input.getAttribute('data-birthday-locale') || document.documentElement.lang,
      flatpickr
    );
    var picker = flatpickr(input, {
      allowInput: false,
      clickOpens: !input.disabled,
      dateFormat: 'Y-m-d',
      disableMobile: true,
      locale: localeKey === 'default' ? flatpickr.l10ns.default : flatpickr.l10ns[localeKey],
      positionElement: config.positionElement || input
    });

    if (picker && picker.calendarContainer) {
      picker.calendarContainer.classList.add('renogy-flatpickr');
    }

    picker.config.onValueUpdate.push(function (_selectedDates, dateStr) {
      input.dataset.lastBirthdayValue = dateStr || '';
    });

    return picker;
  }

  function isValidDateString(value) {
    var normalized = String(value || '').trim();
    if (!normalized) return true;
    if (!/^\d{4}-\d{2}-\d{2}$/.test(normalized)) return false;

    if (window.flatpickr && typeof window.flatpickr.parseDate === 'function') {
      var parsed = window.flatpickr.parseDate(normalized, 'Y-m-d');
      return !!(
        parsed &&
        !Number.isNaN(parsed.getTime()) &&
        window.flatpickr.formatDate(parsed, 'Y-m-d') === normalized
      );
    }

    var parts = normalized.split('-');
    var parsedYear = Number(parts[0]);
    var parsedMonth = Number(parts[1]) - 1;
    var parsedDate = Number(parts[2]);
    var fallback = new Date(parsedYear, parsedMonth, parsedDate);

    return (
      !Number.isNaN(fallback.getTime()) &&
      fallback.getFullYear() === parsedYear &&
      fallback.getMonth() === parsedMonth &&
      fallback.getDate() === parsedDate
    );
  }

  window.RenogyFlatpickr = {
    initBirthdayPicker: initBirthdayPicker,
    isValidDateString: isValidDateString
  };
})(window);
